export default __webpack_public_path__ + "static/GT-Super-Display-Super-d1453cd5cc747d38396f11d153c36a39.woff2";